export default "__VITE_ASSET__4WdCmQSI__"